document.addEventListener('DOMContentLoaded', function(){






    document.getElementById('compatibilityButton').addEventListener('click', function () {
            document.getElementById('popupOverlay').style.display = 'flex';


     
        });

document.querySelector(".check-button").addEventListener("click", function () {
  document.querySelector(".popup-overlay").classList.toggle("active");
});

  
const closeBtn = document.querySelector('.close-btn');
const popupOverlay = document.querySelector('.popup-overlay');


if (closeBtn && popupOverlay) {
  closeBtn.addEventListener('click', () => {
  
    popupOverlay.classList.remove('active');
  });
}


        // Close when clicking X
        document.getElementById('closeBtn').addEventListener('click', function () {
            document.getElementById('popupOverlay').style.display = 'none';
        });

        // Close when clicking outside popup
        document.getElementById('popupOverlay').addEventListener('click', function (e) {
            if (e.target === this) {
                this.style.display = 'none';
            }
        });
  
 
});

  
